import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

/**
 * Compact Booking Stepper
 * Props:
 * - currentStep (number)
 * - steps (array of { id, title })
 */
export default function BookingStepper({ currentStep = 1, steps = [] }) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{
        mb: { xs: 1, sm: 2 },
        px: { xs: 0.5, sm: 1 },
      }}
    >
      {steps.map((step, index) => {
        const isCompleted = step.id < currentStep;
        const isCurrent = step.id === currentStep;

        return (
          <React.Fragment key={step.id}>
            <Stack alignItems="center" sx={{ position: "relative", flex: 1 }}>
              {/* Circle */}
              <Box
                sx={{
                  width: 38,
                  height: 38,
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  bgcolor: isCompleted
                    ? "#22c55e" // green for completed
                    : isCurrent
                    ? "#1976d2" // active blue
                    : "#e0e7ff", // neutral soft blue
                  color: isCompleted || isCurrent ? "white" : "#64748b",
                  boxShadow: isCurrent
                    ? "0 0 0 4px rgba(25, 118, 210, 0.25)"
                    : "none",
                  transition: "all 0.3s ease",
                }}
              >
                {isCompleted ? <CheckCircle sx={{ fontSize: 20 }} /> : step.id}
              </Box>

              {/* Label */}
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  fontWeight: isCurrent ? 600 : 400,
                  color: isCompleted
                    ? "#22c55e"
                    : isCurrent
                    ? "#1976d2"
                    : "#94a3b8",
                  textAlign: "center",
                  maxWidth: 90,
                  lineHeight: 1.2,
                }}
              >
                {step.title}
              </Typography>
            </Stack>

            {/* Connector */}
            {index < steps.length - 1 && (
              <Box
                sx={{
                  flexGrow: 1,
                  height: 2,
                  bgcolor: isCompleted ? "#22c55e" : "#e2e8f0",
                  mt: 2,
                  mx: 0.5,
                  transition: "background-color 0.3s",
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </Stack>
  );
}
